import { render, staticRenderFns } from "./OneProject.vue?vue&type=template&id=6518bb54&scoped=true"
import script from "./OneProject.vue?vue&type=script&lang=js"
export * from "./OneProject.vue?vue&type=script&lang=js"
import style0 from "./OneProject.vue?vue&type=style&index=0&id=6518bb54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6518bb54",
  null
  
)

export default component.exports